import React from 'react';

/**
 * 24-hour "HH:mm" picker. A native <input type="time"> follows the browser's
 * locale and shows AM/PM outside Türkiye settings; this always reads 13:30.
 * Value in/out is the same "HH:mm" string the native input used.
 */
interface Props {
  value: string;
  onChange: (value: string) => void;
  'aria-label': string;
  /** Minute step; an existing minute that is off-step is still listed. */
  minuteStep?: number;
}

const pad = (n: number) => String(n).padStart(2, '0');
const cls = 'bg-white rounded-[12px] px-2 h-[42px] outline-none text-[14px] border border-[#cfd8e6] focus:border-[#3973bf] tabular-nums';

const TimeField24: React.FC<Props> = ({ value, onChange, 'aria-label': ariaLabel, minuteStep = 5 }) => {
  const [h = '', m = ''] = value ? value.split(':') : [];
  const hours = Array.from({ length: 24 }, (_, i) => pad(i));
  const minutes = Array.from({ length: Math.ceil(60 / minuteStep) }, (_, i) => pad(i * minuteStep));
  if (m && !minutes.includes(m)) { minutes.push(m); minutes.sort(); }
  const emit = (nh: string, nm: string) => onChange(`${nh || '00'}:${nm || '00'}`);
  return (
    <span className="inline-flex items-center gap-1" role="group" aria-label={ariaLabel}>
      <select aria-label={`${ariaLabel} – saat`} value={h} onChange={(e) => emit(e.target.value, m)} className={cls}>
        {!h && <option value="" />}
        {hours.map((x) => <option key={x} value={x}>{x}</option>)}
      </select>
      <span aria-hidden>:</span>
      <select aria-label={`${ariaLabel} – dakika`} value={m} onChange={(e) => emit(h, e.target.value)} className={cls}>
        {!m && <option value="" />}
        {minutes.map((x) => <option key={x} value={x}>{x}</option>)}
      </select>
    </span>
  );
};

export default TimeField24;
